import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { pageDataHeaderOffersSelectors } from '@ucheba/store/page-data/for-abiturients/headerOffers'
import { IHeaderOffersItem } from '@ucheba/store/page-data/for-abiturients/headerOffers/types'
import { useRouter } from 'next/router'

interface IUseGetHeaderOffersItemCore {
  (): {
    headerOffersItem: IHeaderOffersItem | null | undefined
    timerHeaderOffer: boolean
  }
}

export const useGetSchoolHeaderOffersItem: IUseGetHeaderOffersItemCore = () => {
  const dataHeaderOffers = useSelector(pageDataHeaderOffersSelectors.entity)

  const { query } = useRouter()

  const headerOffersItem = useMemo(() => {
    if (dataHeaderOffers) {
      return dataHeaderOffers?.headerOffers.find((el) => el.slug === query.offer)
    }
    return null
  }, [dataHeaderOffers, query.offer])

  const timerHeaderOffer = useMemo(() => {
    if (headerOffersItem) {
      const endDate = new Date(headerOffersItem?.endDate)
      const currentDate = Date.now()
      return endDate.getTime() > currentDate
    }
    return false
  }, [headerOffersItem])

  return { headerOffersItem, timerHeaderOffer }
}
